import { render } from "./alarm.vue?vue&type=template&id=9aba18b4&scoped=true"
import script from "./alarm.vue?vue&type=script&lang=js"
export * from "./alarm.vue?vue&type=script&lang=js"

import "./alarm.vue?vue&type=style&index=0&id=9aba18b4&lang=scss&scoped=true"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9aba18b4"]])

export default __exports__